<template>
    <div class="background">
        <div class="dialog-box" :class="styleMessage">
            <i :class="styleMessage === 'danger' ? 'fas fa-times-circle' : 'fas fa-check-circle'"/>
            <h6>{{title}}</h6>
            <p>{{message}}</p>
            <button @click="CHANGE_MESSAGE_MODAL({
                show:false,
                title: '',
                message: '',
                styleMessage: 'danger'
            })" class="btn-modal">
                Entendi
            </button>
        </div>
    </div>
</template>

<script>
    import ButtonLarge from "./buttons/ButtonLg";
    import {mapMutations} from "vuex";
    export default {
        name: "MessageModal",
        components: {ButtonLarge},
        props:[
          'styleMessage',
          'title',
          'message',
        ],
        data(){
            return{
                modal: false
            }
        },
        methods:{
            ...mapMutations(["CHANGE_MESSAGE_MODAL"])
        }
    }
</script>

<style scoped>
    .background{
        background-color: rgba(0, 0, 0, 0.9);
        width: 100%;
        height: 100vh;
        position: fixed;
        top:0;
        left: 0;
        z-index: 500;
        margin: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .dialog-box{
        background: #ffffff;
        width: 333px;
        padding: 40px;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        text-align: center;
    }

    .dialog-box i{
        font-size: 100px;
        margin: 0 0 40px 0;
    }

    .dialog-box.danger i{
        color: #c1345e;
    }

    .dialog-box.success i{
        color: #0077BD;
    }

    .dialog-box.alert i{
        color: var(--blackColor);
    }

    .dialog-box h6{
        font-family: "Roboto Black";
        font-weight: normal;
        font-size: 24px;
        color: var(--blackColor);
        margin-bottom: 15px;
        line-height: 28px;
    }

    .dialog-box p{
        font-size: 14px;
        font-family: "Roboto";
        color: var(--grayColor);
        margin-bottom: 50px;
    }

    .btn-modal{
        height: 48px;
        padding: 0 48px;
        color: #ffffff;
        font-family: "Roboto Black";
        font-size: 18px;
        border-radius: 20px;
        border: 0;
        cursor: pointer;
    }

    .dialog-box.danger .btn-modal{
        background: #c1345e;
    }

    .dialog-box.success .btn-modal{
        background: #0077BD;
    }

    .dialog-box.alert .btn-modal{
        background: var(--blackColor);
    }

</style>
